import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar.js";
import { Topbar } from "./Topbar.js";

export function Shell() {
  const [menu, setMenu] = useState(false);
  const cerrarMenu = useCallback(() => setMenu(false), []);
  return (
    <div className="h-full flex">
      <Sidebar abierto={menu} onCerrar={cerrarMenu} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar menuAbierto={menu} onMenu={() => setMenu(true)} />
        <main className="relative flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
